import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { ComboboxEmpty, ComboboxEmptyProps } from '@anyui/core';
import { useSelectContext } from '../select-context';

export const SelectEmpty = ({ className, children, ...restProps }: ComboboxEmptyProps) => {
  const { t } = useTranslation();
  const {
    selectProps: { classNames, emptyMessage }
  } = useSelectContext();

  return (
    <ComboboxEmpty className={cn('order-1', className, classNames?.empty)} {...restProps}>
      {emptyMessage || children || t('No options found')}
    </ComboboxEmpty>
  );
};
